export const captchaTypes = {
  RECAPTCHA: 'recaptcha',
};
